import Alert from '@/models/entities/api/alert';
import { API_RESULT_TYPE } from '@/models/entities/api/api-result-type';

export default class ApiResponse {
  apiResultType: typeof API_RESULT_TYPE.RESPONSE;

  code: number;

  message: string;

  alerts?: Array<Alert>;

  constructor(source: unknown) {
    this.apiResultType = API_RESULT_TYPE.RESPONSE;
    this.code = (source as any).code;
    this.message = (source as any).message;
    this.alerts = (source as any).alerts;
  }
}
